import { render } from "./orgAnalyseDetail.vue?vue&type=template&id=635dac77&scoped=true"
import script from "./orgAnalyseDetail.vue?vue&type=script&lang=js"
export * from "./orgAnalyseDetail.vue?vue&type=script&lang=js"

import "./orgAnalyseDetail.vue?vue&type=style&index=0&id=635dac77&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635dac77"]])

export default __exports__